import { API } from 'aws-amplify';
import * as Sentry from "@sentry/react";

/**
 * Central API wrapper around AWS Amplify's API client.
 * All HTTP errors are automatically captured by Sentry with useful context,
 * then re-thrown so existing callers can still handle them as before.
 */

function captureApiError(error, method, path, extra = {}) {
    const status = error?.response?.status ?? error?.statusCode ?? null;
    Sentry.captureException(error, {
        extra: {
            method,
            path,
            status,
            ...extra,
        },
    });
}

export const apiGet = async (path, requestInfo) => {
    try {
        return await API.get('apiAssessment', path, requestInfo);
    } catch (error) {
        captureApiError(error, 'GET', path);
        throw error;
    }
};

export const apiPost = async (path, requestInfo) => {
    try {
        return await API.post('apiAssessment', path, requestInfo);
    } catch (error) {
        captureApiError(error, 'POST', path);
        throw error;
    }
};

export const apiPut = async (path, requestInfo) => {
    try {
        return await API.put('apiAssessment', path, requestInfo);
    } catch (error) {
        captureApiError(error, 'PUT', path);
        throw error;
    }
};

export const apiDel = async (path, requestInfo) => {
    try {
        return await API.del('apiAssessment', path, requestInfo);
    } catch (error) {
        captureApiError(error, 'DELETE', path);
        throw error;
    }
};
